import { IModule, IModules, IModuleTile } from '../interfaces/interfaces';

export const colsConfig: { [key: string]: number } = { xl: 4, lg: 3, md: 3, sm: 2, xs: 1, xxs: 1 };
export const breakpoints: { [key: string]: number } = { xl: 1280, lg: 960, md: 840, sm: 600, xs: 321, xxs: 0 };

export const getBreakpointForWidth = (width: number): string => {
  let bp = 'lg';
  Object.keys(breakpoints)
    .sort((a, b) => {
      return breakpoints[a] - breakpoints[b];
    })
    .forEach((bpKey) => {
      if (width > breakpoints[bpKey]) {
        bp = bpKey;
      }
    });
  return bp;
};

export const sortedByPosition = (tileSet: IModuleTile[]) => {
  return tileSet.sort((a, b) => {
    return a.layout.y - b.layout.y || a.layout.x - b.layout.x;
  });
};

export const recompPositions = (
  tileSet: IModuleTile[],
  cols: number,
  currentBreakpoint: string,
  availableModules: IModules,
) => {
  let x = 0;
  let y = 0;
  return tileSet.map((tile) => {
    if (x > 0 && tile.layout.w > cols - x) {
      y += 1;
      x = 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fixModuleLayouts = ((availableModules as any)[tile.module] as IModule).fixLayouts || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fixModuleLayoutForBP = (fixModuleLayouts as any)[currentBreakpoint];

    const layout =
      {
        ...tile.layout,
        i: tile.id,
        x,
        y,
        w: fixModuleLayoutForBP?.w || tile.layout.w,
        h: fixModuleLayoutForBP?.h || tile.layout.h,
      } || tile.layout;

    x += tile.layout.w;
    if (x >= cols) {
      y += 1;
      x = 0;
    }
    return layout;
  });
};
